var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderAll(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5292 2.29297C19.5292 2.29297 21.9292 4.69297 21.9292 7.69297C21.9292 10.693 19.5292 13.093 16.5292 13.093C13.5292 13.093 11.1292 10.693 11.1292 7.69297C11.1292 4.69297 13.5292 2.29297 16.5292 2.29297ZM16.5292 12.093C18.9292 12.093 20.8292 10.193 20.8292 7.79297C20.8292 5.39297 18.9292 3.49297 16.5292 3.49297C14.1292 3.49297 12.2291 5.39297 12.2291 7.79297C12.2291 10.193 14.1292 12.093 16.5292 12.093Z",
    fill: "#787E82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4758 13.7462L19.4758 11.7462L20.1829 11.0391L22.1829 13.0391L21.4758 13.7462Z",
    fill: "#787E82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3259 2C12.5328 2.52049 11.8558 3.20245 11.3416 4H7.81812V6H10.4705C10.3359 6.53239 10.2644 7.08987 10.2644 7.66406C10.2644 7.77672 10.2678 7.88869 10.2732 8H5.81812V6H3.81812V20H17.8181V14.3887C18.5238 14.3074 19.1956 14.1171 19.8181 13.8359V21.0068C19.818 21.5553 19.3724 22 18.824 22H2.81128C2.26272 22 1.81727 21.5552 1.81714 21.0068V4.99316C1.81727 4.44463 2.26291 4 2.81128 4H5.81812V2H13.3259Z",
    fill: "#525256"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderAll);
export default __webpack_public_path__ + "static/media/order-all.c3997778ddd9760c04b9069bb428e3e8.svg";
export { ForwardRef as ReactComponent };